<script>
    import { mapGetters } from 'vuex';
    import ChannelSetup from './channels';
    import WebChat from './webchat';
    import WelcomeComponent from '../../../../components/onboarding/welcomebanner';

    export default {
        layout: 'dashboard',

        components: { ChannelSetup, WebChat, WelcomeComponent },

        computed: {
            ...mapGetters([
                'chat_setup_view'
            ])
        },

        methods: {
            fetchAccountProducts() {
                this.$store.dispatch('FETCH_SUBSCRIPTION_PRODUCTS');
            }
        },

        mounted() {
            //this.fetchAccountProducts();
        }
    }
</script>

<template>
    <div class="row">
        <welcome-component product="Chats"/>
        <div class="narrow-width-page">
            <channel-setup/>
        </div>

    </div>
</template>

<style scoped>
    .narrow-width-page {
        padding: 1%;
    }
</style>

